// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { List, Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetMarketAll (params?: {}): Promise<List>;
    publicGetCandlesTimeframe (params?: {}): Promise<List>;
    publicGetCandlesTimeframeUnit (params?: {}): Promise<List>;
    publicGetCandlesSeconds (params?: {}): Promise<List>;
    publicGetCandlesMinutesUnit (params?: {}): Promise<List>;
    publicGetCandlesMinutes1 (params?: {}): Promise<List>;
    publicGetCandlesMinutes3 (params?: {}): Promise<List>;
    publicGetCandlesMinutes5 (params?: {}): Promise<List>;
    publicGetCandlesMinutes10 (params?: {}): Promise<List>;
    publicGetCandlesMinutes15 (params?: {}): Promise<List>;
    publicGetCandlesMinutes30 (params?: {}): Promise<List>;
    publicGetCandlesMinutes60 (params?: {}): Promise<List>;
    publicGetCandlesMinutes240 (params?: {}): Promise<List>;
    publicGetCandlesDays (params?: {}): Promise<List>;
    publicGetCandlesWeeks (params?: {}): Promise<List>;
    publicGetCandlesMonths (params?: {}): Promise<List>;
    publicGetCandlesYears (params?: {}): Promise<List>;
    publicGetTradesTicks (params?: {}): Promise<List>;
    publicGetTicker (params?: {}): Promise<List>;
    publicGetTickerAll (params?: {}): Promise<List>;
    publicGetOrderbook (params?: {}): Promise<List>;
    publicGetOrderbookInstruments (params?: {}): Promise<List>;
    privateGetAccounts (params?: {}): Promise<Dict>;
    privateGetOrdersChance (params?: {}): Promise<Dict>;
    privateGetOrder (params?: {}): Promise<Dict>;
    privateGetOrdersClosed (params?: {}): Promise<List>;
    privateGetOrdersOpen (params?: {}): Promise<List>;
    privateGetOrdersUuids (params?: {}): Promise<List>;
    privateGetWithdraws (params?: {}): Promise<List>;
    privateGetWithdraw (params?: {}): Promise<Dict>;
    privateGetWithdrawsChance (params?: {}): Promise<Dict>;
    privateGetWithdrawsCoinAddresses (params?: {}): Promise<List>;
    privateGetDeposits (params?: {}): Promise<List>;
    privateGetDepositsChanceCoin (params?: {}): Promise<Dict>;
    privateGetDeposit (params?: {}): Promise<Dict>;
    privateGetDepositsCoinAddresses (params?: {}): Promise<List>;
    privateGetDepositsCoinAddress (params?: {}): Promise<Dict>;
    privateGetTravelRuleVasps (params?: {}): Promise<List>;
    privateGetStatusWallet (params?: {}): Promise<List>;
    privateGetApiKeys (params?: {}): Promise<List>;
    privateGetPockets (params?: {}): Promise<List>;
    privateGetPocketsApiKeys (params?: {}): Promise<List>;
    privateGetPocketsAssets (params?: {}): Promise<List>;
    privateGetPocketsUniversalTransfers (params?: {}): Promise<List>;
    privateGetPocketsTransfers (params?: {}): Promise<List>;
    privatePostOrders (params?: {}): Promise<Dict>;
    privatePostOrdersTest (params?: {}): Promise<Dict>;
    privatePostOrdersCancelAndNew (params?: {}): Promise<Dict>;
    privatePostWithdrawsCoin (params?: {}): Promise<Dict>;
    privatePostWithdrawsKrw (params?: {}): Promise<Dict>;
    privatePostDepositsKrw (params?: {}): Promise<Dict>;
    privatePostDepositsGenerateCoinAddress (params?: {}): Promise<Dict>;
    privatePostTravelRuleDepositUuid (params?: {}): Promise<Dict>;
    privatePostTravelRuleDepositTxid (params?: {}): Promise<Dict>;
    privatePostPocketsUniversalTransfers (params?: {}): Promise<Dict>;
    privatePostPocketsTransfers (params?: {}): Promise<Dict>;
    privateDeleteOrder (params?: {}): Promise<Dict>;
    privateDeleteOrdersOpen (params?: {}): Promise<Dict>;
    privateDeleteOrdersUuids (params?: {}): Promise<Dict>;
    privateDeleteWithdrawsCoin (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
